module.exports = __webpack_public_path__ + "img/flat-eprice-button-ford.e27d633b.png";